export default "__VITE_ASSET__DRFkQXve__"